export const AI_CONNECTIONS_ENABLED = import.meta.env.VITE_ENABLE_AI_CONNECTIONS === 'true';
